import {
  SidePanelActionTypes,
  SidePanelActions,
  SidePanelOpeningContext,
} from 'actions/ReservationsSidePanelActions';

export interface State {
  sidePanelContext?: SidePanelOpeningContext;
}

export const initialState: State = {
  sidePanelContext: undefined,
};

export default function reducer(state = initialState, action: SidePanelActions): State {
  switch (action.type) {
    case SidePanelActionTypes.SIDE_PANEL_OPEN: {
      return {
        ...state,
        sidePanelContext: action.payload,
      };
    }
    case SidePanelActionTypes.SIDE_PANEL_CLOSE: {
      return {
        ...state,
        sidePanelContext: undefined,
      };
    }
    default:
      return state;
  }
}
